import { defineStore } from 'pinia'
import { Explotacion } from '@/models/Explotacion';
import { Preferences } from '@capacitor/preferences';

interface ExplotacionStore {
  explotacion: Explotacion;
  explotaciones: Explotacion[];
}
export const useExplotacionStore = defineStore('explotacion', {
  
  state: (): ExplotacionStore => ({
    explotacion: {} as Explotacion,
    explotaciones: [] as Explotacion[]
  }),
  
  actions: {
     async set(explotacion:Explotacion){

        this.explotacion = explotacion;

        await Preferences.set({
          key: 'explotacion',
          value: JSON.stringify(explotacion),
        });
     },
    async clear(){
          // Limpiar todos los datos de Preferences
          await Preferences.remove({ key: 'explotacion'});
          this.explotacion = {} as Explotacion;
          this.explotaciones = [] as Explotacion[];
    }
  },
  getters:{
      async get(state){
          // Obtener el usuario desde Preferences
          const { value } = await Preferences.get({ key: 'explotacion' });
          state.explotacion = value ? JSON.parse(value) : null;
          return state.explotacion;
      }
  }
})